import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=0edab1ad&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=ts&"
export * from "./Voucher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edab1ad",
  null
  
)

export default component.exports